var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.5C0 11.6421 3.35786 15 7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5ZM14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5Z",
    fill: "#981BAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58473 4.04051C3.30202 3.90598 3.03789 3.76274 2.79978 3.61452L2 3.00009L2.5 2.50009H2.94166C3.205 2.70858 3.54448 2.91292 3.92978 3.1004C4.55785 1.61581 5.54308 0.332908 7 0.0900879V1.00009C6.12122 1.00009 5.3176 2.03716 4.76374 3.45325C5.65675 3.78071 6.65732 4.00009 7.5 4.00009C9.02775 4.00009 11.0745 3.27903 12.0583 2.50009H12.5L13 3.00009L12.2002 3.61452C10.9826 4.37251 9.08439 5.00009 7.5 5.00009C6.52361 5.00009 5.42806 4.76176 4.44605 4.40144C4.16403 5.39383 4 6.48456 4 7.50009C4 10.4359 5.37086 14.0001 7 14.0001V14.9801C4 14.4801 3 9.50009 3 7.50009C3 6.67236 3.17128 5.34621 3.58473 4.04051Z",
    fill: "#981BAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2363 11.5469C9.34325 11.2195 8.34268 11.0001 7.5 11.0001C5.97225 11.0001 3.92554 11.7211 2.94166 12.5001H2.5L2 12.0001L2.79978 11.3857C4.01742 10.6277 5.91561 10.0001 7.5 10.0001C8.47639 10.0001 9.57194 10.2384 10.5539 10.5987C10.836 9.60634 11 8.51561 11 7.50009C11 4.56432 9.62914 1.00009 8 1.00009V0.0900879C11 0.590088 12 5.50009 12 7.50009C12 8.32307 11.8307 9.65065 11.4223 10.963C11.7024 11.0966 11.9641 11.2387 12.2002 11.3857L13 12.0001L12.5 12.5001H12.0583C11.7979 12.2939 11.4629 12.0917 11.0829 11.9059C10.4554 13.4203 9.46673 14.7356 8 14.9801V14.0001C8.87878 14.0001 9.6824 12.963 10.2363 11.5469Z",
    fill: "#981BAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7V1H8V7H14V8H8V14H7V8H1V7H7Z",
    fill: "#981BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.390bb1f816c5de67ac16ce38ed325928.svg";
export { ForwardRef as ReactComponent };